import { render, staticRenderFns } from "./ContentContainerComponent.vue?vue&type=template&id=1ae3277f"
import script from "./ContentContainerComponent.vue?vue&type=script&lang=js"
export * from "./ContentContainerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports